/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteMultipleLabelsInput = {
    ids?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteMultipleLabelsMutationVariables = {
    input: DeleteMultipleLabelsInput;
};
export type deleteMultipleLabelsMutationResponse = {
    readonly deleteMultipleLabels: {
        readonly deletedLabelIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type deleteMultipleLabelsMutation = {
    readonly response: deleteMultipleLabelsMutationResponse;
    readonly variables: deleteMultipleLabelsMutationVariables;
};



/*
mutation deleteMultipleLabelsMutation(
  $input: DeleteMultipleLabelsInput!
) {
  deleteMultipleLabels(input: $input) {
    deletedLabelIds
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMultipleLabelsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleLabelsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleLabels",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMultipleLabelsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMultipleLabelsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteMultipleLabelsMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMultipleLabelsMutation(\n  $input: DeleteMultipleLabelsInput!\n) {\n  deleteMultipleLabels(input: $input) {\n    deletedLabelIds\n  }\n}\n"
  }
};
})();
(node as any).hash = '03e08d8ab0b2b42ec654e5b7a293a7ee';
export default node;
